import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Tag } from 'primereact/tag';
import './FlujoCotizaciones.scss';

// ---------- Datos ----------

const ESTATUS = {
    1: { n: 'Nuevo', c: '#3b82f6' },
    2: { n: 'En planeación', c: '#8b5cf6' },
    3: { n: 'En costeo', c: '#f59e0b' },
    9: { n: 'Costeado', c: '#d97706' },
    4: { n: 'Enviada al cliente', c: '#0891b2' },
    8: { n: 'Cambios solicitados', c: '#f97316' },
    5: { n: 'Aprobado', c: '#16a34a' },
    6: { n: 'En producción', c: '#15803d' },
    7: { n: 'Rechazada', c: '#dc2626' }
};

const RESUMEN = [
    { icon: 'pi-pencil', quien: 'In-plant / Atención', hace: 'Captura y hace las modificaciones de trazo' },
    { icon: 'pi-map', quien: 'Johana', hace: 'Valida y apoya en rutas nuevas' },
    { icon: 'pi-calculator', quien: 'Judy', hace: 'Pone precio y envía' },
    { icon: 'pi-user', quien: 'Cliente', hace: 'Responde en el panel' },
    { icon: 'pi-thumbs-up', quien: 'Eduardo', hace: 'Manda a producción' }
];

const FLUJO_A = [
    {
        id: 1, icon: 'pi-pencil', quien: 'In-plant / Atención a clientes',
        hace: 'Capturan toda la cotización (ruta, horarios, días y unidad). En modificaciones (extensión, reducción o paradas) ellos hacen los cambios al trazo. Son los encargados principales.',
        edita: 'Todos los datos', accion: 'Verificar datos', permiso: 'CONFIRMAR DATOS'
    },
    {
        id: 2, icon: 'pi-map', quien: 'Johana (Planeación)',
        hace: 'Valida que la ruta sea óptima y que los datos sean coherentes. Si la ruta es completamente nueva, ayuda a crear el trazo; en modificaciones solo corrige si detecta algo mal.',
        edita: 'Trazos y paradas', accion: 'Verificar trazos', permiso: 'VERIFICAR TRAZOS',
        nota: { tipo: 'warn', icon: 'pi-undo', texto: 'En modificaciones, si llega sin el trazo ajustado o con datos incompletos, se regresa a In-plant / Atención para que lo completen.' }
    },
    {
        id: 3, icon: 'pi-calculator', quien: 'Costeo (Judy)',
        hace: 'Define el precio al cliente y los costos de la ruta (pago al chofer, chofer sencillo y subcontratista).',
        edita: 'Costos', accion: 'Guardar costos', permiso: 'DEFINIR COSTOS'
    },
    {
        id: 9, icon: 'pi-check-square', quien: 'Costeo (Judy)',
        hace: 'Los costos están listos. Judy envía la cotización al cliente.',
        edita: 'Nada', accion: 'Enviar al cliente (escribir ENVIAR)', permiso: 'ENVIAR AL CLIENTE',
        nota: { tipo: 'warn', icon: 'pi-replay', texto: 'En 3 · En costeo o 9 · Costeado, Judith puede pedir cambios antes de enviarla. Pasa a 8 · Cambios solicitados.' }
    },
    {
        id: 4, icon: 'pi-send', quien: 'El cliente',
        hace: 'Recibe el PDF por correo. Todo queda bloqueado hasta que responda.',
        edita: 'Nada', accion: 'Respuesta desde el panel del cliente',
        nota: { tipo: 'bad', icon: 'pi-exclamation-triangle', texto: 'Debe responder desde el panel del cliente. Si responde por correo o teléfono el estatus no cambia y Eduardo no puede continuar.' }
    }
];

const FLUJO_B = [
    {
        id: 5, icon: 'pi-thumbs-up', quien: 'Eduardo (Operaciones)',
        hace: 'Ajusta los pagos al operador y deja comentarios. Elige la fecha de inicio y confirma escribiendo ACEPTAR; si la fecha ya pasó se aplica retroactivo.',
        edita: 'Pagos al operador', accion: 'Mandar a producción', permiso: 'MANDAR A PRODUCCIÓN'
    },
    {
        id: 6, icon: 'pi-cog', quien: 'El sistema',
        hace: 'Copia rutas, estructuras, trazos y paradas a producción. Si la fecha es futura, queda programado para ese día.',
        edita: 'Nada'
    }
];

const RESPUESTAS = [
    { tipo: 'ok', icon: 'pi-check-circle', titulo: 'Acepta', id: 5, texto: 'Sigue a producción.' },
    { tipo: 'warn', icon: 'pi-replay', titulo: 'Pide cambios', id: 8, texto: 'Se guarda en CAMBIOS_SOLICITADOS. Se ajusta solo lo pedido y se reenvía.' },
    { tipo: 'bad', icon: 'pi-times-circle', titulo: 'Rechaza', id: 7, texto: 'Se guarda en MOTIVO_RECHAZO. Fin: queda bloqueada.' }
];

const ROLES = [
    { icon: 'pi-pencil', quien: 'In-plant y Atención a clientes', principal: true, hace: 'Capturan toda la información. En modificaciones (extensión, reducción o paradas) hacen los cambios al trazo, paradas y horarios.' },
    { icon: 'pi-map', quien: 'Johana (Planeación)', hace: 'Valida que la ruta sea óptima y los datos coherentes. En rutas completamente nuevas ayuda a crear el trazo.', no: 'Capturar datos ni hacer las modificaciones de trazo (extensión, reducción o paradas).' },
    { icon: 'pi-calculator', quien: 'Judy (Costeo)', hace: 'Define el precio al cliente y envía la cotización.' },
    { icon: 'pi-thumbs-up', quien: 'Eduardo (Operaciones)', hace: 'Ajusta pagos al operador y manda a producción.' }
];

const PERMISOS = [
    [1, 'Todos los datos', true, false, false],
    [2, 'Trazos y paradas', true, false, false],
    [3, 'Costos', true, false, false],
    [9, 'Nada', true, true, false],
    [4, 'Nada', false, false, false],
    [8, 'Lo que se pidió cambiar', false, false, false],
    [5, 'Pagos al operador', true, false, 'Sí, si no es referencia'],
    [6, 'Nada', false, false, 'Ya enviada'],
    [7, 'Nada', false, false, false]
];

const COMENTARIOS = [
    ['Nuevo', [1], 'Personas asignadas (In-plant / Atención)'],
    ['Planeación', [2], 'Johana'],
    ['Costeo', [3, 9], 'Judith'],
    ['Aprobado', [5], 'Eduardo']
];

const TIPOS = [
    { pide: 'Mover la hora de entrada o salida, o cambiar días, sin tocar el recorrido', elige: ['Cambio de horarios'], edita: 'Hora, días y tipo de servicio (Medio, Sencillo)' },
    { pide: 'Otra unidad (autobús en lugar de camioneta)', elige: ['Cambio de unidad'], edita: 'Nueva unidad para toda la ruta', sinEstructuras: true },
    { pide: 'Alargar el recorrido', elige: ['Extensión de trazo'], edita: 'Trazo en el mapa y horarios' },
    { pide: 'Acortar el recorrido', elige: ['Reducción de trazo'], edita: 'Trazo en el mapa y horarios' },
    { pide: 'Agregar, quitar o mover paradas sin modificar los turnos', elige: ['Modificar paradas'], edita: 'Solo paradas; no permite editar turnos' },
    { pide: 'Cambiar horarios y el trazo o las paradas', elige: ['Cambio de horarios', 'Extensión / Reducción de trazo'], edita: 'Hora, días, tipo de servicio y trazo' },
    { pide: 'Cambiar el tipo de turno y el trazo o las paradas', elige: ['Cambios en la frecuencia', 'Extensión / Reducción de trazo'], edita: 'Turno, horarios, días y trazo' },
    { pide: 'Cambiar horarios y agregar turnos nuevos', elige: ['Cambios en la frecuencia → Ambas opciones'], edita: 'Turno, horarios, días y copias de turnos' },
    { pide: 'Un turno nuevo basado en uno existente (turno extra)', elige: ['Cambios en la frecuencia → Generar nueva estructura'], edita: 'Copia del turno, sin tocar el original' },
    { pide: 'Cambiar el turno asignado a una estructura', elige: ['Cambios en la frecuencia → Modificar estructura existente'], edita: 'Turno, horarios y días (ej. Salida T1 → Salida Semi Domiciliado)' }
];

const MODOS = [
    { icon: 'pi-pencil', titulo: 'Modificar estructura existente', hace: 'Edita horarios, días y turno de las estructuras originales. No crea nada nuevo.', cuando: 'El turno sigue existiendo pero cambia su hora o su recorrido.' },
    { icon: 'pi-copy', titulo: 'Generar nueva estructura', hace: 'Crea una copia «(Copia)» de cada estructura seleccionada. La original no cambia.', cuando: 'El cliente quiere un servicio adicional parecido a uno que ya tiene.' },
    { icon: 'pi-clone', titulo: 'Ambas opciones', hace: 'Por cada turno eliges Editar existente, Generar copia o Ambas.', cuando: 'En la misma solicitud unos turnos cambian y otros se duplican.' }
];

const PASOS_HORARIOS = [
    { t: 'En el listado de cotizaciones, haz clic en Cotizar Edición de Ruta.' },
    {
        t: 'Paso 1 – Selecciona la ruta a modificar', sub: [
            'Elige Cliente, Ticket asociado y Ruta, en ese orden. Cambiar cliente o ticket borra lo capturado después.',
            'Revisa el ticket con el botón del ojo para confirmar qué pidió el cliente.',
            'En Tipo de cambio elige solo Cambio de horarios.',
            'Captura la Fecha tentativa de ejecución y el Correo de notificación (ahí llega el aviso al costearse).',
            'Marca solo los turnos que vas a modificar; esos son los que se actualizan y los demás no cambian.'
        ]
    },
    { t: 'Paso 2 – Ajusta horario, Días de operación y Tipo de servicio de cada turno. Compara con el recuadro Valores originales.' },
    { t: 'Paso 3 – Revisa el resumen y haz clic en Guardar Cotización. Si algo está mal, usa Anterior.' }
];

const PASOS_FRECUENCIA = [
    { t: 'En el listado, haz clic en Cotizar Edición de Ruta.' },
    {
        t: 'Paso 1', sub: [
            'Elige Cliente, Ticket asociado y Ruta.',
            'Elige Cambios en la frecuencia. Si cambia el recorrido agrega Extensión o Reducción de trazo; si cambia la unidad, Cambio de unidad.',
            'Elige el modo: Modificar existente, Generar nueva o Ambas.',
            'Captura la fecha tentativa y el correo de notificación.',
            'Marca solo los turnos que cambian o que se van a copiar. En modo Ambas, indica en cada turno Editar existente, Generar copia o Ambas.'
        ]
    },
    {
        t: 'Paso 2', sub: [
            'Turnos a editar: ajusta Turno, Tipo de servicio, hora en planta y Días de operación.',
            'Copias: aparecen como «(Copia)»; captura hora de inicio, fin y días. Si una sobra, bórrala con el ícono de basura.'
        ]
    },
    { t: 'Paso 3 – Revisa y guarda. Pasa al detalle, donde In-plant / Atención ajusta el trazo y después Johana lo valida.' }
];

const PASOS_TRAZO = [
    { t: 'Haz clic en Modificar recorrido de Ida (o Regreso) para editar todos los turnos juntos, o en Editar trazo de un turno para uno solo. Si los turnos tienen paradas distintas, se editan por separado.' },
    { t: 'El editor tiene cuatro pasos: Info, Paradas, Horarios y Guardar.' },
    { t: 'En Paradas agrega, mueve o quita paradas; usa Deshacer, Restaurar o Invertir orden y marca paradas De control con la bandera.' },
    { t: 'En Horarios captura la hora de cada parada por turno. La hora en planta se llena sola (última parada en entrada, primera en salida).' },
    { t: 'Guarda. Si sales sin guardar, al volver puedes Restaurar el borrador o Descartarlo.' },
    { t: 'Con el trazo completo, haz clic en Mandar a costeo.' }
];

const ACCIONES = [
    ['pi-pencil', 'Editar cotización de modificación', 'Listado, lápiz', 'Nuevo, En planeación o Cambios solicitados', 'Reabre el asistente. Guarda con Actualizar Cotización.'],
    ['pi-pencil', 'Editar cotización de ruta nueva', 'Listado, lápiz', 'Nuevo o Cambios solicitados', 'Reabre el asistente de nueva cotización.'],
    ['pi-trash', 'Eliminar', 'Listado, basura', 'Con permiso: Nuevo, En planeación, En costeo o Cambios solicitados', 'Borra tras confirmar con Sí, eliminar. No se puede deshacer.'],
    ['pi-arrow-right-arrow-left', 'Cambiar estatus', 'Listado, flechas', 'Solo con permiso', 'Mueve la cotización a otro estatus manualmente.'],
    ['pi-link', 'Marcar como combinable', 'Detalle', 'Operaciones, en estatus no bloqueados', 'La asocia a una ruta activa combinable. Se quita con Quitar combinable.'],
    ['pi-tag', 'Precio de referencia', 'Detalle', 'Operaciones (MARCAR PRECIO REFERENCIA)', 'Unidad no disponible: se envía al cliente pero no va a producción.'],
    ['pi-flag', 'Parada de control', 'Editor de trazo, Paradas', 'In-plant / Atención', 'Marca un punto de control; su nombre es automático y no se edita.'],
    ['pi-sitemap', 'Revisar flujo', 'Listado', 'Todos', 'Abre esta guía.']
];

const ERRORES = [
    ['No marcar un turno que sí cambia', 'Ese turno no se actualiza y se queda como estaba', 'Marca todos los turnos que el cliente pidió cambiar'],
    ['Elegir solo Cambios en la frecuencia cuando cambia el recorrido', 'No deja editar trazo ni paradas', 'Combínala con Extensión o Reducción de trazo'],
    ['Elegir Modificar paradas cuando también cambian horarios', 'No deja editar los horarios', 'Usa Extensión o Reducción de trazo'],
    ['Elegir solo Cambio de horarios cuando cambian paradas', 'El trazo no refleja el nuevo recorrido', 'Combínalo con Extensión o Reducción de trazo'],
    ['Elegir Cambios en la frecuencia cuando solo cambian horas', 'Pasos extra y copias que nadie pidió', 'Si el turno no cambia, usa Cambio de horarios'],
    ['Usar «Generar nueva estructura» para corregir un horario', 'Queda el turno viejo y uno duplicado', 'Usa Modificar estructura existente'],
    ['Dejar a Planeación el trazo de una modificación', 'La cotización se detiene; en modificaciones Johana solo valida', 'In-plant / Atención hacen extensión, reducción y paradas'],
    ['Cambiar cliente o ticket a mitad del Paso 1', 'Se borra ruta, tipo de cambio y estructuras', 'Elige cliente, ticket y ruta antes que nada'],
    ['Quitar «Cambios en la frecuencia» del tipo de cambio', 'Se descartan modo, copias y turnos elegidos', 'Decide el tipo de cambio antes de marcar turnos'],
    ['Dejar un turno sin días de operación', 'El botón Siguiente no se habilita', 'Cada turno con al menos un día'],
    ['Pedir al cliente que responda por correo o teléfono', 'El estatus no cambia y el proceso se detiene', 'Que responda desde el panel del cliente']
];

const FAQ = [
    ['¿Por qué no puedo editar la hora de inicio de un turno de entrada?', 'Se calcula a partir de las paradas. Captura la hora de llegada a planta y ajusta las paradas en el editor de trazo.'],
    ['¿Puedo combinar Cambio de unidad con otros cambios?', 'Sí. Aplica a toda la ruta y se puede agregar a cualquier otro tipo.'],
    ['¿Qué pasa si borré una copia por error?', 'Regresa al Paso 1, desmarca y vuelve a marcar el turno (o vuelve a elegir «Generar copia» o «Ambas»). La copia se genera de nuevo al avanzar.'],
    ['Cuando se piden cambios, ¿se empieza de cero?', 'No. Todo se conserva; solo se modifica lo que se pidió y cada área vuelve a verificar su parte.']
];

// ---------- Piezas reutilizadas ----------

const Estatus = ({ id }) => (
    <span className="fc-estatus" style={{ '--c': ESTATUS[id].c }}>
        <b>{id}</b>{ESTATUS[id].n}
    </span>
);

const Aviso = ({ tipo = 'info', icon = 'pi-info-circle', titulo, children }) => (
    <div className={`fc-aviso fc-aviso--${tipo}`} role="note">
        <i className={`pi ${icon}`} aria-hidden="true" />
        <div>
            {titulo && <h4>{titulo}</h4>}
            {children}
        </div>
    </div>
);

const Nodo = ({ id, icon, quien, hace, edita, accion, permiso, nota }) => (
    <>
        <div className="fc-nodo" style={{ '--c': ESTATUS[id].c }}>
            <span className="fc-nodo__icono"><i className={`pi ${icon}`} aria-hidden="true" /></span>
            <div className="fc-nodo__cuerpo">
                <div className="flex flex-wrap align-items-center gap-2 mb-2">
                    <Estatus id={id} />
                    <span className="fc-quien"><i className="pi pi-user" aria-hidden="true" /> {quien}</span>
                </div>
                <p>{hace}</p>
                <small className="fc-muted"><i className="pi pi-pencil" aria-hidden="true" /> Se puede editar: <b>{edita}</b></small>
            </div>
        </div>
        {nota && <div className="fc-nodo-nota"><Aviso tipo={nota.tipo} icon={nota.icon}>{nota.texto}</Aviso></div>}
        {accion && (
            <div className="fc-flecha">
                <i className="pi pi-arrow-down" aria-hidden="true" />
                <span>{accion}</span>
                {permiso && <Tag value={permiso} severity="info" rounded />}
            </div>
        )}
    </>
);

const Pasos = ({ items }) => (
    <ol className="fc-pasos">
        {items.map((p) => (
            <li key={p.t}>
                <span>{p.t}</span>
                {p.sub && <ul>{p.sub.map((s) => <li key={s}>{s}</li>)}</ul>}
            </li>
        ))}
    </ol>
);

const Si = ({ v }) => (
    v === true ? <i className="pi pi-check fc-si" aria-label="Sí" />
        : v === false ? <i className="pi pi-minus fc-no" aria-label="No" />
            : <span className="fc-si">{v}</span>
);

// ---------- Vista ----------

const FlujoCotizaciones = () => (
    <div className="flujo-cotizaciones">
        <header className="fc-hero">
            <h1>Flujo de cotizaciones empresariales</h1>
            <p>Cómo avanza una cotización, quién hace qué y cómo capturar cambios de ruta sin errores.</p>
            <div className="fc-resumen">
                {RESUMEN.map((r, i) => (
                    <div key={r.quien} className="fc-resumen__item">
                        <span className="fc-resumen__n">{i + 1}</span>
                        <i className={`pi ${r.icon}`} aria-hidden="true" />
                        <b>{r.quien}</b>
                        <small>{r.hace}</small>
                    </div>
                ))}
            </div>
        </header>

        <TabView scrollable className="fc-tabs">
            {/* ---------------- FLUJO ---------------- */}
            <TabPanel header="Flujo" leftIcon="pi pi-sitemap mr-2">
                <div className="fc-flujo">
                    {FLUJO_A.map((n) => <Nodo key={n.id} {...n} />)}

                    <div className="grid mt-1">
                        {RESPUESTAS.map((r) => (
                            <div key={r.id} className="col-12 md:col-4">
                                <div className={`fc-respuesta fc-respuesta--${r.tipo}`}>
                                    <h4><i className={`pi ${r.icon}`} aria-hidden="true" /> {r.titulo}</h4>
                                    <Estatus id={r.id} />
                                    <p>{r.texto}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="fc-flecha"><i className="pi pi-arrow-down" aria-hidden="true" /><span>Si el cliente aprueba</span></div>
                    {FLUJO_B.map((n) => <Nodo key={n.id} {...n} />)}
                </div>

                <h2><i className="pi pi-replay" aria-hidden="true" /> Cuando se piden cambios</h2>
                <Aviso tipo="ok" icon="pi-shield" titulo="No se borra nada">
                    La cotización no empieza de cero: datos, horarios, trazos, paradas y costos se quedan como estaban. Solo se modifica lo que se pidió, como corregir un documento ya escrito.
                </Aviso>

                <div className="grid mt-2">
                    <div className="col-12 md:col-6">
                        <div className="fc-card h-full">
                            <h3>¿Quién puede pedirlos?</h3>
                            <ul className="fc-lista">
                                <li><b>Judith</b>, en <Estatus id={3} /> o <Estatus id={9} />, antes de enviarla.</li>
                                <li><b>El cliente</b>, en <Estatus id={4} />, siempre desde el panel del cliente.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="fc-card h-full">
                            <h3>¿Qué sigue?</h3>
                            <Pasos items={[
                                { t: 'Pasa a 8 · Cambios solicitados y lo pedido queda escrito en el sistema.' },
                                { t: 'Cada área revisa su parte en el mismo orden. Casi siempre solo es abrir y Verificar; trabaja solo el área a la que le toca el cambio.' },
                                { t: 'Se reenvía y regresa a 4 · Enviada al cliente.' }
                            ]} />
                        </div>
                    </div>
                </div>

                <h3 className="fc-h3">Dos ejemplos</h3>
                <div className="grid">
                    <div className="col-12 md:col-6">
                        <div className="fc-card fc-ejemplo h-full">
                            <h3><i className="pi pi-car" aria-hidden="true" /> Solo otra unidad</h3>
                            <p className="fc-muted">«En lugar de camioneta, quiero un autobús».</p>
                            <ul className="fc-lista">
                                <li><b>In-plant / Atención:</b> cambia la unidad y verifica.</li>
                                <li><b>Johana:</b> confirma que el trazo sigue igual y verifica. No se redibuja nada.</li>
                                <li><b>Judy:</b> ajusta el precio de la nueva unidad.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="fc-card fc-ejemplo h-full">
                            <h3><i className="pi pi-map-marker" aria-hidden="true" /> Cambia el recorrido</h3>
                            <p className="fc-muted">«Agreguen una parada en la colonia Centro».</p>
                            <ul className="fc-lista">
                                <li><b>In-plant / Atención:</b> abre el trazo existente y agrega o mueve solo lo necesario.</li>
                                <li><b>Johana:</b> valida que la ruta siga óptima.</li>
                                <li><b>Judy:</b> revisa si los kilómetros nuevos cambian el precio.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <Aviso icon="pi-question-circle" titulo="¿Por qué verificar si no cambió nada?">
                    Un cambio en una parte puede afectar otra: una unidad más grande quizá no pasa por una calle del trazo, o una parada nueva sube los kilómetros y el precio.
                </Aviso>

                <h2><i className="pi pi-tag" aria-hidden="true" /> Precio de referencia</h2>
                <div className="fc-card fc-card--ref">
                    <Tag value="REFERENCIA" severity="warning" className="mb-2" />
                    <ul className="fc-lista">
                        <li><b>Quién:</b> Operaciones, con el permiso MARCAR PRECIO REFERENCIA, en estatus no bloqueados.</li>
                        <li><b>Por qué:</b> la unidad no está disponible.</li>
                        <li><b>Qué ve el cliente:</b> un aviso en el PDF de que el precio no confirma disponibilidad.</li>
                        <li><b>Qué bloquea:</b> se puede enviar al cliente, pero <b>no mandar a producción</b>.</li>
                    </ul>
                </div>
            </TabPanel>

            {/* ---------------- ROLES Y PERMISOS ---------------- */}
            <TabPanel header="Roles y permisos" leftIcon="pi pi-users mr-2">
                <div className="grid">
                    {ROLES.map((r) => (
                        <div key={r.quien} className="col-12 md:col-6">
                            <div className={`fc-card fc-rol h-full ${r.principal ? 'fc-rol--principal' : ''}`}>
                                <div className="flex align-items-center gap-2 mb-2">
                                    <span className="fc-rol__icono"><i className={`pi ${r.icon}`} aria-hidden="true" /></span>
                                    <h3 className="m-0">{r.quien}</h3>
                                    {r.principal && <Tag value="Encargados principales" severity="success" rounded />}
                                </div>
                                <p>{r.hace}</p>
                                {r.no && <p className="fc-rol__no"><i className="pi pi-ban" aria-hidden="true" /> No le corresponde: {r.no}</p>}
                            </div>
                        </div>
                    ))}
                </div>

                <h2><i className="pi pi-lock" aria-hidden="true" /> Qué se puede hacer en cada estatus</h2>
                <div className="fc-tabla">
                    <table>
                        <thead>
                        <tr><th>Estatus</th><th>Qué se edita</th><th>Comentar</th><th>Enviar al cliente</th><th>A producción</th></tr>
                        </thead>
                        <tbody>
                        {PERMISOS.map(([id, edita, comentar, enviar, prod]) => (
                            <tr key={id}>
                                <td><Estatus id={id} /></td>
                                <td>{edita}</td>
                                <td><Si v={comentar} /></td>
                                <td><Si v={enviar} /></td>
                                <td><Si v={prod} /></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

                <h2><i className="pi pi-comments" aria-hidden="true" /> Comentarios por estatus</h2>
                <div className="fc-tabla">
                    <table>
                        <thead><tr><th>Sección</th><th>Estatus</th><th>Quién escribe</th></tr></thead>
                        <tbody>
                        {COMENTARIOS.map(([seccion, ids, quien]) => (
                            <tr key={seccion}>
                                <td><b>{seccion}</b></td>
                                <td><div className="flex flex-wrap gap-1">{ids.map((id) => <Estatus key={id} id={id} />)}</div></td>
                                <td>{quien}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <p className="fc-muted">Solo se escribe mientras la cotización está en ese estatus. Todos pueden leer cualquier sección y un comentario solo lo edita quien lo escribió.</p>

                <h2><i className="pi pi-bolt" aria-hidden="true" /> Otras acciones</h2>
                <div className="fc-tabla">
                    <table>
                        <thead><tr><th>Acción</th><th>Dónde</th><th>Quién / cuándo</th><th>Qué hace</th></tr></thead>
                        <tbody>
                        {ACCIONES.map(([icon, accion, donde, quien, hace]) => (
                            <tr key={accion}>
                                <td className="white-space-nowrap"><i className={`pi ${icon} mr-2 fc-accent`} aria-hidden="true" /><b>{accion}</b></td>
                                <td>{donde}</td>
                                <td>{quien}</td>
                                <td>{hace}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </TabPanel>

            {/* ---------------- TIPOS DE CAMBIO ---------------- */}
            <TabPanel header="¿Qué tipo de cambio elijo?" leftIcon="pi pi-compass mr-2">
                <Aviso tipo="gold" icon="pi-star-fill" titulo="Regla de oro">
                    <b>Cambio de horarios</b> cambia hora, días y tipo de servicio. <b>Cambios en la frecuencia</b> hace lo mismo y además cambia el tipo de turno o crea turnos nuevos. <b>Ninguno cambia el trazo</b>: para eso combínalos con Extensión o Reducción de trazo.
                </Aviso>

                <Aviso tipo="info" icon="pi-check-square" titulo="Selecciona solo las estructuras que cambian">
                    En una modificación no es necesario marcar todas. Las estructuras que selecciones en el Paso 1 <b>son las que se actualizan</b>; las demás se quedan como están en la ruta.
                </Aviso>

                <h2><i className="pi pi-list-check" aria-hidden="true" /> Busca tu caso</h2>
                <div className="grid">
                    {TIPOS.map((t) => (
                        <div key={t.pide} className="col-12 md:col-6 xl:col-4">
                            <div className="fc-card fc-tipo h-full">
                                <small className="fc-label">Si el cliente pide…</small>
                                <p className="fc-tipo__pide">{t.pide}</p>
                                <small className="fc-label">Elige</small>
                                <div className="flex flex-wrap align-items-center gap-1 mb-2">
                                    {t.elige.map((e, i) => (
                                        <span key={e} className="flex align-items-center gap-1">
                                            {i > 0 && <i className="pi pi-plus fc-muted" aria-hidden="true" />}
                                            <span className="fc-chip">{e}</span>
                                        </span>
                                    ))}
                                </div>
                                <small className="fc-muted"><i className="pi pi-pencil" aria-hidden="true" /> {t.edita}</small>
                                {t.sinEstructuras && <div className="mt-2"><Tag value="No selecciona estructuras" severity="secondary" /></div>}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="grid">
                    <div className="col-12 md:col-6">
                        <Aviso tipo="warn" icon="pi-info-circle">
                            <b>Cambios en la frecuencia</b> sola no permite cambiar trazo ni paradas.
                        </Aviso>
                    </div>
                    <div className="col-12 md:col-6">
                        <Aviso tipo="warn" icon="pi-info-circle">
                            <b>Modificar paradas</b> no deja editar horarios. Si cambian ambos, usa Extensión o Reducción de trazo.
                        </Aviso>
                    </div>
                </div>
                <p className="fc-muted">Puedes combinar varios tipos (selección múltiple), por ejemplo Cambio de unidad + Cambio de horarios.</p>

                <h2><i className="pi pi-clone" aria-hidden="true" /> Los tres modos de Cambios en la frecuencia</h2>
                <p className="fc-muted">Al elegir Cambios en la frecuencia aparece un selector obligatorio: no podrás avanzar sin elegir uno.</p>
                <div className="grid">
                    {MODOS.map((m) => (
                        <div key={m.titulo} className="col-12 md:col-4">
                            <div className="fc-card fc-modo h-full">
                                <span className="fc-rol__icono mb-2"><i className={`pi ${m.icon}`} aria-hidden="true" /></span>
                                <h3>{m.titulo}</h3>
                                <p>{m.hace}</p>
                                <p className="fc-modo__cuando"><b>Úsalo cuando:</b> {m.cuando}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </TabPanel>

            {/* ---------------- PASO A PASO ---------------- */}
            <TabPanel header="Paso a paso" leftIcon="pi pi-list mr-2">
                <h2 className="mt-0"><i className="pi pi-clock" aria-hidden="true" /> Cambio de horarios (sin cambiar el trazo)</h2>
                <p className="fc-muted">El recorrido y las paradas se quedan igual; solo cambian horas, días o tipo de servicio.</p>
                <div className="fc-card"><Pasos items={PASOS_HORARIOS} /></div>

                <h3 className="fc-h3">Cómo editar las horas</h3>
                <p className="fc-muted">Solo se edita una de las dos horas de cada turno; la otra se calcula con el horario de las paradas.</p>
                <div className="grid">
                    {[
                        ['Entrada', 'pi-sign-in', 'Lleva al personal a planta', 'Hora llegada a planta', 'Hora de inicio de turno'],
                        ['Salida', 'pi-sign-out', 'Recoge al personal en planta', 'Hora inicio en planta', 'Hora fin de turno']
                    ].map(([tipo, icon, desc, capturas, calcula]) => (
                        <div key={tipo} className="col-12 md:col-6">
                            <div className="fc-card fc-hora h-full">
                                <h3><i className={`pi ${icon}`} aria-hidden="true" /> {tipo}</h3>
                                <p className="fc-muted">{desc}</p>
                                <div className="fc-hora__fila fc-hora__fila--tu"><i className="pi pi-pencil" aria-hidden="true" /><span>Tú capturas</span><b>{capturas}</b></div>
                                <div className="fc-hora__fila"><i className="pi pi-sync" aria-hidden="true" /><span>Se calcula sola</span><b>{calcula}</b></div>
                            </div>
                        </div>
                    ))}
                </div>
                <ul className="fc-lista">
                    <li>Captura siempre la <b>hora en planta</b>, que es la que conoce el cliente. La otra se recalcula al ajustar las paradas.</li>
                    <li>Cada turno necesita <b>al menos un día</b> de operación o Siguiente queda deshabilitado.</li>
                    <li>Aquí no se cambia el Turno asignado: usa Cambios en la frecuencia → Modificar estructura existente.</li>
                </ul>

                <h2><i className="pi pi-clone" aria-hidden="true" /> Cambios en la frecuencia (tipo de turno y copias)</h2>
                <p className="fc-muted">Cuando cambia el tipo de turno (ej. S1 a SSD) o hay que crear un turno a partir de otro. Sola no cambia trazo ni paradas.</p>
                <div className="fc-card"><Pasos items={PASOS_FRECUENCIA} /></div>

                <h2><i className="pi pi-map" aria-hidden="true" /> Ajustar el trazo y las paradas</h2>
                <p className="fc-muted">En modificaciones (extensión, reducción o paradas) lo hace In-plant / Atención y Johana valida; en rutas completamente nuevas, Johana ayuda a crear el trazo. En el detalle verás Recorrido de Ida y de Regreso; Regreso se habilita cuando Ida está listo.</p>
                <div className="fc-card"><Pasos items={PASOS_TRAZO} /></div>
            </TabPanel>

            {/* ---------------- ERRORES Y DUDAS ---------------- */}
            <TabPanel header="Errores y dudas" leftIcon="pi pi-exclamation-circle mr-2">
                <h2 className="mt-0"><i className="pi pi-exclamation-triangle" aria-hidden="true" /> Errores comunes</h2>
                <div className="grid">
                    {ERRORES.map(([error, consecuencia, solucion]) => (
                        <div key={error} className="col-12 md:col-6 xl:col-4">
                            <div className="fc-card fc-error h-full">
                                <p className="fc-error__mal"><i className="pi pi-times-circle" aria-hidden="true" /> {error}</p>
                                <p className="fc-muted">{consecuencia}</p>
                                <p className="fc-error__bien"><i className="pi pi-check-circle" aria-hidden="true" /> {solucion}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <h2><i className="pi pi-question-circle" aria-hidden="true" /> Preguntas frecuentes</h2>
                <Accordion multiple activeIndex={[0]}>
                    {FAQ.map(([p, r]) => (
                        <AccordionTab key={p} header={p}><p className="m-0">{r}</p></AccordionTab>
                    ))}
                </Accordion>
            </TabPanel>
        </TabView>
    </div>
);

export default FlujoCotizaciones;